import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const welcomeGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // Simulating an asynchronous check (e.g., an API call to validate the token)
  return new Promise<boolean>(async (resolve) => {
    const accessToken = localStorage.getItem('ALTOMATE_ACCESS_TOKEN_KEY');
    if (accessToken) {
      // If the token exists, allow navigation
      router.navigate(['/home']);
      resolve(false);
    } else {
      // If no token, redirect to login page
      resolve(true);
    }
  });

};